export default "__VITE_ASSET__Bzn5NEck__"